import { noteAccessVersion } from '../hooks/usePermissions';

// Friendly feedback when the server refuses something because of the user's role.
//
// The server answers 403 { code: 'PERMISSION_DENIED', message } (see utils/access.js). Many
// screens already show an error message; the rest used to fail silently, which looks like a
// broken button. This shows one clear toast — unless the page already put the same words on
// screen — and signs the user out if their account was switched off.

let hideTimer = null;

function showToast(message) {
  if (typeof document === 'undefined') return;
  let el = document.getElementById('cx-access-toast');
  if (!el) {
    el = document.createElement('div');
    el.id = 'cx-access-toast';
    el.setAttribute('role', 'alert');
    el.style.cssText = [
      'position:fixed', 'top:18px', 'right:18px', 'z-index:100002', 'max-width:360px', 'display:flex', 'gap:10px',
      'align-items:flex-start', 'padding:12px 14px', 'border-radius:12px', 'background:#fff', 'color:#0f1f45',
      'border:1px solid #fed7aa', 'box-shadow:0 12px 32px rgba(15,31,69,.18)', 'font:13px/1.5 system-ui,sans-serif',
    ].join(';');
    document.body.appendChild(el);
  }
  el.innerHTML = '<span style="flex-shrink:0;width:22px;height:22px;border-radius:50%;background:#ffedd5;color:#c2410c;' +
    'display:flex;align-items:center;justify-content:center;font-weight:700;font-size:12px">!</span>';
  const text = document.createElement('span');
  text.textContent = message;
  el.appendChild(text);
  el.style.display = 'flex';
  clearTimeout(hideTimer);
  hideTimer = setTimeout(() => { el.style.display = 'none'; }, 5000);
}

export function installAccessFeedback(nativeFetch) {
  return function fetchWithFeedback(url, options) {
    return nativeFetch(url, options).then((res) => {
      const isApi = typeof url === 'string' && url.includes('/api/');
      // role changed by an admin? (see noteAccessVersion) — /me itself is what we compare against
      if (isApi && !url.includes('/api/access/me')) noteAccessVersion(res.headers.get('X-Access-Version'));
      if (isApi && (res.status === 403 || res.status === 401)) {
        res.clone().json().then((b) => {
          if (!b) return;
          if (b.code === 'PERMISSION_DENIED') {
            // give the page a moment to show its own message first
            setTimeout(() => {
              if (!document.body.innerText.includes(b.message)) showToast(b.message);
            }, 300);
          } else if (b.code === 'ACCOUNT_DISABLED') {
            try { localStorage.removeItem('token'); localStorage.removeItem('user'); } catch { /* ignore */ }
            window.location.assign('/');
          }
        }).catch(() => {});
      }
      return res;
    });
  };
}
